import { Flex, Text, List } from '@mantine/core';

interface WinnerContentProps {
  description: string;
  nextStepsTitle: string;
  nextSteps: string[];
  closingText: string;
}

export const WinnerContent = ({
  description,
  nextStepsTitle,
  nextSteps,
  closingText,
}: WinnerContentProps) => {
  return (
    <Flex gap="10px" direction="column">
      <Text size="16px" lh="24px" c="#202020">
        {description}
      </Text>
      <Text size="16px" lh="24px" c="#202020" fw="700">
        {nextStepsTitle}
      </Text>
      <List spacing="xs" c="#202020">
        {nextSteps.map((step, index) => (
          <List.Item key={index}>{step}</List.Item>
        ))}
      </List>
      <Text size="16px" lh="24px" c="#202020">
        {closingText}
      </Text>
    </Flex>
  );
};
